import { fetchApi } from '@/config/axiosSetting.ts';
import { FileStatesQueryResponseType } from '@/common/queries/selections/fileStates/fileStateQuery.type.ts';

export const fileStateQueryFunctions = (): Promise<
  FileStatesQueryResponseType[]
> => fetchApi.get('my_files/file_state/');
